import { Component, OnInit, Input } from '@angular/core';

import { productSlider } from '../data';

@Component({
	selector: 'molla-electronics-collection',
	templateUrl: './electronics-collection.component.html',
	styleUrls: ['./electronics-collection.component.scss']
})

export class ElectronicsCollectionComponent implements OnInit {

	@Input() products = [];
	@Input() loaded = false;

	sliderOption = productSlider;
	//attrs = ['featured', 'new', 'top'];
	attrs = ['featured', '_new', 'top'];
	titles = { "featured": "In Evidenza", "_new": "New", "top": "Best Seller" };

	constructor() { }

	ngOnInit(): void {
	}
}
